module.exports = __webpack_public_path__ + "home/en-US/js/home-tabs/images/abcmouse-tab-active-dt-e05c7d7adb963a6d1efca8cb20e6c43c.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/home-tabs/images/abcmouse-tab-active-dt.png
// module id = nhvm
// module chunks = 0